export const getSpacing = (isRootPath: boolean): number => (isRootPath ? 0 : 3);
